import ExpandableSection from "@/components/job/ExpandableSection";
import useCUMechanicalJobStore from "@/store/useCUMechanicalJobStore";

import {
  StrongbackTypeLocationForm,
  type StrongbackTypeLocationSchema,
} from "./StrongbackTypeLocation/StrongbackTypeLocationForm";

const cardName = "strongbackTypeLocation";

export function StrongbackTypeLocationDetails() {
  const { sections, toggleExpandableSection, setStrongbackTypeLocation } = useCUMechanicalJobStore();
  const strongbacks = sections.strongbacks;
  const strongbackTypeLocation = sections.strongbackTypeLocation;
  const materialData = strongbacks.data;
  const typeData = strongbackTypeLocation.data;
  const matchFlag = materialData.match_strongback_to_enclosure;

  const materialsComplete =
    matchFlag === true || (matchFlag === false && !!materialData.strongbacks && !!materialData.strongbacks_stud_bolts);

  const canShow = strongbacks.addMore && matchFlag !== undefined && materialsComplete;

  return (
    <ExpandableSection
      setIsExpanded={() => toggleExpandableSection(cardName)}
      status={canShow ? strongbackTypeLocation.status : "hidden"}
      title="Strongback Type and Location Detail"
    >
      {canShow ? (
        <StrongbackTypeLocationForm
          defaultValues={{
            strongback_header: "strongback_header" in typeData ? (typeData.strongback_header as boolean) : undefined,
            strongback_riser: "strongback_riser" in typeData ? (typeData.strongback_riser as boolean) : undefined,
            strongback_top: "strongback_top" in typeData ? (typeData.strongback_top as boolean) : undefined,
            strongback_bottom: "strongback_bottom" in typeData ? (typeData.strongback_bottom as boolean) : undefined,
            match_strongback_to_enclosure:
              "match_strongback_to_enclosure" in typeData
                ? (typeData.match_strongback_to_enclosure as boolean)
                : undefined,
            strongbacks:
              "strongbacks" in typeData && Array.isArray((typeData as any).strongbacks)
                ? ((typeData as any).strongbacks as Record<string, unknown>[])
                : [],
          }}
          onSave={(formData: StrongbackTypeLocationSchema) => {
            setStrongbackTypeLocation({
              data: {
                ...typeData,
                ...formData,
                match_strongback_to_enclosure: matchFlag,
              },
              status: "done",
            });
          }}
        />
      ) : (
        <p className="text-gray-600 text-sm">
          Complete Strongback Material Details first to enter type and location information.
        </p>
      )}
    </ExpandableSection>
  );
}
